import type { ReactNode } from 'react'
import { StyleSheet, View } from 'react-native'
import { Sidebar } from './Sidebar'

interface DesktopShellProps {
    children: ReactNode
}

export function DesktopShell({ children }: DesktopShellProps) {
    return (
        <View style={styles.container}>
            <Sidebar />
            <View style={styles.content}>{children}</View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
    },
    content: {
        flex: 1,
    },
})
